module.exports = __webpack_public_path__ + "static/media/Aditya_Choudhary.c58d3bc4.jpg";